// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qN5lZ","importantInfo":"styles_importantInfo__3ViKk"};